import { FETCH_STORE_PRODUCTS } from "../actionTypes"

export default (state = {}, action=null) => {
  if (action.type === FETCH_STORE_PRODUCTS)  {
    return { ...state, ...action.payload };
  } else {
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/products.js